<template>
  <form @submit.prevent="sendMessage">
    <ion-grid>
      <ion-row>
        <ion-col size="8">
          <ion-item>
            <ion-input
                :modelValue="userInput"
                @ionChange="onInputChange"
                placeholder="Ihre Frage eingeben (v06)"
                clear-input
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="2">
          <ion-button
              type="submit"
              expand="block"
              :disabled="!userInput || loading"
              style="height: 100%;"
          >
            <ion-spinner v-if="loading"></ion-spinner>
            <span v-else>Senden</span>
          </ion-button>
        </ion-col>
        <ion-col size="2">
          <ion-button
              color="danger"
              expand="block"
              @click="resetChat"
              style="height: 100%;"
          >
            Verlauf löschen
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</template>

<script>
import { IonGrid, IonRow, IonCol, IonItem, IonInput, IonButton, IonSpinner } from '@ionic/vue';

export default {
  name: 'ChatInput',
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonInput,
    IonButton,
    IonSpinner,
  },
  props: {
    userInput: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    sendMessage: {
      type: Function,
      required: true,
    },
    onInputChange: {
      type: Function,
      required: true,
    },
    resetChat: {
      type: Function,
      required: true,
    },
  },
};
</script>